import { useEffect, useState } from "react";
import { ToastTypes } from "../../../../../contexts/toastr.context";
import { useToast } from "../../../../../hooks/use-toast.hook";
import { PaymentPreferenceMethod } from "../../../../../types/payment-preference/payment-preference-method.type";
import { PaymentPreference } from "../../../../../types/payment-preference/payment-preference.type";
import { Fold } from "../../../../../_utils/extensions/typescript-utils";
import LinkBankAccountView from "./link-bank-account-component";
import LinkRazorPayView from "./link-razorpay-component";

type Status = "idle" | "loading" | "success" | "error";

export interface handleConnectPaymentPreferenceProps {
  payload: any;
  onSuccess: (paymentPreference: PaymentPreference) => void;
  onFailed: (error: any) => void;
}

export interface handleDisconnectPaymentPreferenceProps {
  onSuccess: (reference: PaymentPreference) => void;
  onFailed: (error: any) => void;
}

/**
 * Component to select default currency and payment gateway
 */
export function PaymentMethodSelectionComponent({
  community,
  paymentPreference,
  onPaymentPreferenceUpdate,
}: {
  community: any;
  user: any;
  paymentPreference: {
    preference: PaymentPreference;
    status: Status;
  };
  onPaymentPreferenceUpdate: (
    payload: any,
    onSuccess: (_: PaymentPreference) => void,
    onFailed: (_: any) => void
  ) => void;
}) {
  const [paymentGateway, setPaymentGateway] =
    useState<PaymentPreferenceMethod>("bank-account");
  const [status, setStatus] = useState<Status>("idle");
  const toast = useToast();

  // Set payment gateway method from redux
  useEffect(() => {
    if (
      paymentPreference?.preference?.paymentMethod &&
      paymentPreference?.preference?.paymentMethod !== "not-set"
    ) {
      setPaymentGateway(paymentPreference?.preference?.paymentMethod);
    }
  }, [paymentPreference]);

  // Save razorpay account details
  const handleConnectPaymentPreference = ({
    payload,
    onFailed = () => {},
    onSuccess = () => {},
  }: handleConnectPaymentPreferenceProps) => {
    setStatus("loading");
    onPaymentPreferenceUpdate(
      payload,
      (paymentPreference: PaymentPreference) => {
        onSuccess(paymentPreference);
        setStatus("success");
      },
      (error: any) => {
        onFailed(error);
        setStatus("error");
        if (error.response) {
          if (error.response.data.message) {
            toast.addToast(
              "Error",
              error.response.data.message,
              ToastTypes.danger
            );
          } else {
            toast.addToast(
              "Error",
              "Something went wrong, please try again later",
              ToastTypes.danger
            );
          }
        }
      }
    );
  };
  // Make API call to disconnect razorpay account details
  const handleDisconnectPaymentPreference = ({
    onFailed = () => {},
    onSuccess = () => {},
  }: handleDisconnectPaymentPreferenceProps) => {
    const payload = {
      paymentMethod: "not-set",
    };
    setStatus("loading");
    onPaymentPreferenceUpdate(
      payload,
      (paymentPreference: PaymentPreference) => {
        onSuccess(paymentPreference);
        setStatus("success");
      },
      (error: any) => {
        console.log("[Disconnect payment preference error]", error);
        setStatus("error");
        if (error.response) {
          if (error.response.data.message) {
            toast.addToast(
              "Error",
              error.response.data.message,
              ToastTypes.danger
            );
          } else {
            toast.addToast(
              "Error",
              "Something went wrong, please try again later",
              ToastTypes.danger
            );
          }
        }
        onFailed(error);
      }
    );
  };

  return (
    <div className="flex flex-col gap-2 mt-4">
      {/* payment gateway selector */}

      {/* Commented down for now until finds a way to solution of Razorpay */}
      {/* <PaymentGateWaySelector
        className="w-full"
        paymentMethod={paymentGateway}
        label="Choose payment gateway"
        onPaymentMethodChange={setPaymentGateway}
        paymentMethodConnected={
          // Payment method is connected if  payment method is not razorpay
          (["pending", "completed"].includes(
            paymentPreference.preference?.integrationStatus ?? ""
          ) &&
            paymentPreference.preference?.paymentMethod !== "razorpay") ||
          Validator.hasValue(paymentPreference.preference?.razorpay?.razorpayId)
        }
      /> */}

      {/* PAYMENT METHODS */}
      <Fold
        value={paymentGateway === "bank-account"}
        ifPresent={() => (
          <LinkBankAccountView
            community={community}
            status={status}
            paymentPreference={paymentPreference.preference}
            handleDisconnectPaymentPreference={
              handleDisconnectPaymentPreference
            }
            handleConnectPaymentPreference={handleConnectPaymentPreference}
          />
        )}
      />

      <Fold
        value={paymentGateway === "razorpay"}
        ifPresent={() => (
          <LinkRazorPayView
            community={community}
            // paymentPreference={paymentPreference}
            paymentPreference={paymentPreference.preference}
            handleDisconnectPaymentPreference={
              handleDisconnectPaymentPreference
            }
            handleConnectPaymentPreference={handleConnectPaymentPreference}
            status={status}
          />
        )}
      />
    </div>
  );
}
